import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decapitalize'
})
export class DecapitalizePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return null;
  }
}
